<template>
  <div class="bjlsc">
    <headerBanner :bannerUrl='domain+data.bgpic'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i9"></i></div><p>{{data.name}}</p>
    </div>
    <div class="about_detail" v-html='data.content' v-if='data.content'>
    </div>
    <div class="about_detail" v-else>
      <p>安永的大中华业务覆盖中国内地、香港、澳门、台湾及蒙古，让我们的专业服务网络高度整合起来。与此同时，安永也是大中华规模最大的专业服务机构之一，在区内提供专业服务50年。这段期间，安永取得多项具里程碑意义的发展：安永的前身雅特杨会计师事务所（Arthur Young）于1968年在香港成立首个成员办事处；1981年安永成为首批获准在中国内地开业务的国际专业服务机构之一。</p>
      <p>安永大中华区通过27个成员办事处为客户提供服务，办事处地点包括：北京、香港、上海、广州、澳门、深圳、成都、杭州、南京、沈阳、苏州、天津、武汉、西安、长沙、大连、青岛、厦门、郑州和海口。在台湾，安永的办事处设于台北、桃园、新竹、台中、台南和高雄，而蒙古业务的办事处则设在乌兰巴托。</p>
      <p>安永的大中华区员工达18,000名，致力在适当时候，在适当地点配置适当人员，向贵公司提供所需的无缝衔接及优质服务。这就是安永在行业中别树一帜的地方。</p>
      <img src="../../static/images/map.jpg" alt="">
      <div class="about_contact">
        <div class="about_contact_title">
          联系我们：
        </div>
        <p class="address_title">安永大中华区五个主要办事处</p>
        <div class="about_address_wrap clearfix">
          <div class="about_address_item">
            <p class="name">北京</p>
            <p>北京东城区东长安街1号</p>
            <p>东方广场安永大楼16层</p>
            <p>电话：+86 10 5815 3000</p>
          </div> 
          <div class="about_address_item">
            <p class="name">广州</p>
            <p>广州天河区珠江东路13号</p>
            <p>安永大厦18层</p>
            <p>电话：+86 20 2881 2888</p>
          </div>
          <div class="about_address_item">
            <p class="name">香港</p>
            <p>香港中环添美道1号</p>
            <p>中信大厦22楼</p>
            <p>电话：+852 2846 9888 </p>
          </div>
          <div class="about_address_item">
            <p class="name">台北</p>
            <p>台北基隆路一段333号9楼</p>
            <p>电话：+886 2 2757 8888</p>
          </div>
          <div class="about_address_item">
            <p class="name">上海</p>
            <p>上海浦东新区世纪大道100号</p>
            <p>上海环球金融中心50楼</p>
            <p>电话：+86 21 2228 8888</p>
          </div>
        </div>
        <div class="contact_icon">
          <img src="../../static/images/contact_icon.png" alt="">
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'zxxy',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      bannerUrl:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:22
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.cate;
         this.bannerUrl = this.domain+response.body.bgpic
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i9{
    width: 0.38rem;
    height: 0.4rem;
    background-position: -2.18rem -0.1rem;
  }
  .about_detail{
    padding: 0 0.36rem;
    
  }
  .about_detail p{
    font-size: 0.2rem;
    color: #000;
    margin-bottom: 0.1rem;
  }
  .about_detail img{
    width: 5.48rem;
    display: block;
    margin: 0 auto;
    margin-bottom: 0.2rem;
  }
  .about_contact_title{
    font-size: 0.28rem;
    color: #000;
    font-weight: bold;
    margin-bottom: 0.1rem;
  }
  .about_address_item p.name{
    color: #6d6e71;
    font-size: 0.22rem;
  }
  p.address_title{
    font-size: 0.2rem;
    color: #000;
    margin-bottom: 0.2rem;
  }
  .about_address_item p{
    line-height: 0.2rem;
  }
  .about_address_wrap{
    margin-bottom: 0.6rem;
  }
  .about_address_item{
    width: 50%;
    float: left;
    margin-bottom: 0.3rem;
    height: 1rem;
    font-size: 0.2rem;
    color: 000;
  }
  .contact_icon{
    padding-top: 0.15rem;
    padding-left: 0.5rem;
    border-top: 0.02rem solid #ffd200;
    border-bottom: 0.02rem solid #ffd200;
  }
  .contact_icon img{
    width: 4rem;
  }
</style>


// WEBPACK FOOTER //
// src/components/about.vue